export const socialAuthenticationErrors = {
  EMAIL_PERMISSION_NOT_GRANTED: {
    errorCode: "F00001",
    message: "User didn't provide email permission"
  }
};
